import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRequest, postRequest, putRequest } from '../../../axios/requests';
import API from '../../../constant.api';

export const updateDeposit = createAsyncThunk(
  'deposit/update',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.DEPOSITS, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDeposit = createAsyncThunk(
  'deposit/get',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.DEPOSITS, payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const payDeposit = createAsyncThunk(
  'deposit/pay',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.DEPOSIT_PAYMENTS, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const closeDeposit = createAsyncThunk(
  'deposit/close',
  async (payload: { depositNumber: string; data: any }, { rejectWithValue }) => {
    try {
      const res = await postRequest(`${API.DEPOSITS}/close/${payload.depositNumber}`, payload.data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUnsettledDepositPayments = createAsyncThunk(
  'deposit/getUnsettledPayments',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.DEPOSIT_PAYMENTS_UNSETTLED, payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateDepositPaymentStatus = createAsyncThunk(
  'deposit/updatePaymentStatus',
  async (payload: { id: string; status: string }, { rejectWithValue }) => {
    try {
      const res = await putRequest(`${API.DEPOSIT_PAYMENTS}/${payload.id}`, { status: payload.status });
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDepositReceipt = createAsyncThunk(
  'deposit/getReceipt',
  async (depositNumber: string, { rejectWithValue }) => {
    try {
      const res = await getRequest(`${API.DEPOSITS}/receipt/${depositNumber}`, {});
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);